import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../../components/Buttons/Button.js';
import { FormField } from '../../components/Inputs/FormField.js';
import { getMessage } from '../../i18n/messages.js';
export const StepMfaCodeForm = ({ onVerify, loading, className, }) => {
    const { register, handleSubmit, formState: { errors }, } = useForm();
    const onSubmit = (values) => {
        onVerify(values.code);
    };
    return (_jsxs("div", { className: className, children: [_jsx("h2", { children: getMessage('en-US', 'mfaCodeHeading') }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx(FormField, { label: getMessage('en-US', 'mfaCodeLabel'), placeholder: getMessage('en-US', 'mfaPlaceholderCode'), error: errors.code?.message, required: true, 
                        // Modern one-time-code UX: lets the browser auto-fill the SMS/WhatsApp
                        // code, shows the numeric keypad on mobile, and focuses on arrival.
                        inputMode: "numeric", autoComplete: "one-time-code", autoFocus: true, ...register('code', {
                            required: getMessage('en-US', 'mfaCodeRequired'),
                        }) }), _jsx(Button, { htmlType: "submit", fullWidth: true, loading: loading, children: getMessage('en-US', 'verifyButton') })] })] }));
};
//# sourceMappingURL=StepMfaCodeForm.js.map